FeatureSet = require 'app/scripts/lib/feature-set'

businessClassFeatures = [
    'export' # Export org data in a zip file
    'logo' # Custom org logo
    'observers' # Members can be made observers of boards
    'removal' # Members being removed from the org can be taken off all boards and cards in the org
    'activity' # Org admins can see members' last activity in the org
    'deactivated' # Members can be deactivated from orgs to prevent read/write permissions temporarily
    'orgCards' # Org users can see all visible members cards in the org
    'googleApps' # Org can be associated with a google apps domain
    'orgMembersPage' # Admins can use the org members page
    'superAdmins' # Org admins have admin powers on all org boards

    'prefs' # Not an actual feature, just marks the ability to use the preferences menu
    'inviteBoard' # [PREF] Org-level option to restrict board invitations by org membership and enterprise managed status
    'inviteOrg' # [PREF] Org-level option to restrict org invitations by domain name
    'restrictVis' # [PREF] Org-level option to restrict board creation of a certain visibility
]

businessClassFeatures_v2 = [
  businessClassFeatures...
  'goldMembers' # All members get gold
  'csvExport' # Can generate a CSV export.
  'shortExportHistory' # Keep track of last 10 exports
]

businessClassFeatures_v3 = [
  businessClassFeatures_v2...
  "tags" # Boards can be tagged with their organization's named tags
  "plugins" # Plugin integrations are available
]

businessClassFeatures_v3x3 = [
  businessClassFeatures_v3...
  "multiBoardGuests" # Multi-board guests are billable members
]

enterpriseFeatures = [
  businessClassFeatures_v3...
  "enterpriseUI" # The UI says it's enterprise
]

products =
  35:
    shortName: 'businessClassMonthly'
    name: "Business Class"
    interval: 'monthly'
    price: 25
    features: businessClassFeatures
    hidden: true
    prebill: false
    upgrade: true
    yearlyEquivalent: 36
  36:
    shortName: 'businessClassYearly'
    name: "Business Class"
    interval: 'yearly'
    price: 200
    features: businessClassFeatures
    hidden: true
    upgrade: true
  39:
    shortName: 'businessClassMonthly'
    name: "Business Class"
    interval: 'monthly'
    price: 50
    features: businessClassFeatures
    hidden: true
    upgrade: true
    yearlyEquivalent: 40
  40:
    shortName: 'businessClassYearly'
    name: "Business Class"
    interval: 'yearly'
    price: 500
    features: businessClassFeatures
    hidden: true
    upgrade: true
  96:
    shortName: 'businessClassMonthly'
    name: "Business Class"
    interval: 'monthly'
    price: 5
    features: businessClassFeatures_v2
    perUser: true
    upgrade: true
    yearlyEquivalent: 97
  97:
    shortName: 'businessClassYearly'
    name: "Business Class"
    interval: 'yearly'
    price: 45
    features: businessClassFeatures_v2
    perUser: true
    upgrade: true
  98:
    shortName: 'businessClass3Monthly'
    name: "Business Class"
    interval: 'monthly'
    price: 10
    features: businessClassFeatures_v3
    perUser: true
    perActiveUser: true
    yearlyEquivalent: 99
  99:
    shortName: 'businessClass3Yearly'
    name: "Business Class"
    interval: 'yearly'
    price: 100
    features: businessClassFeatures_v3
    perUser: true
    perActiveUser: true
  100:
    shortName: 'enterprise'
    name: "Enterprise"
    interval: 'yearly'
    price: 0
    features: enterpriseFeatures
    perUser: false
    perActiveUser: false
    hidden: true
    purchaseOrder: true
  101:
    shortName: 'businessClass2PO'
    name: "Business Class v2 PO"
    interval: 'yearly'
    price: 0
    features: businessClassFeatures_v2
    perUser: false
    perActiveUser: false
    hidden: true
    purchaseOrder: true
    upgrade: true
  102:
    shortName: 'businessClass3PO'
    name: "Business Class v3 PO"
    interval: 'yearly'
    price: 0
    features: businessClassFeatures_v3
    perUser: false
    perActiveUser: false
    hidden: true
    purchaseOrder: true
  103:
    shortName: 'businessClass3x1Monthly'
    name: "Business Class"
    interval: 'monthly'
    price: 12.50
    features: businessClassFeatures_v3
    perUser: true
    perActiveUser: true
    yearlyEquivalent: 104
  104:
    shortName: 'businessClass3x1Yearly'
    name: "Business Class"
    interval: 'yearly'
    price: 119.99
    features: businessClassFeatures_v3
    perUser: true
    perActiveUser: true
  105:
    shortName: 'businessClass3x2Monthly'
    name: "Business Class"
    interval: 'monthly'
    price: 12.50
    features: businessClassFeatures_v3.concat('toBeUpgradedToMBGPlan')
    perUser: true
    perActiveUser: false
    yearlyEquivalent: 111
  106:
    shortName: 'businessClass3x2Yearly'
    name: "Business Class"
    interval: 'yearly'
    price: 119.99
    features: businessClassFeatures_v3.concat('toBeUpgradedToMBGPlan')
    perUser: true
    perActiveUser: false
  107:
    shortName: 'businessClass3x1PO'
    name: "Business Class v3.1 PO"
    interval: 'yearly'
    price: 0
    features: businessClassFeatures_v3.concat('toBeUpgradedToMBGPlan')
    perUser: false
    perActiveUser: false
    hidden: true
    purchaseOrder: true
  108:
    shortName: 'enterprise1x1TieredPricing'
    name: "Enterprise v1.1"
    interval: 'yearly'
    price: 0
    features: enterpriseFeatures
    perUser: false
    perActiveUser: false
    hidden: true
    purchaseOrder: true
  109:
    shortName: 'enterprise1x2SiteLicense'
    name: "Enterprise v1.2"
    interval: 'yearly'
    price: 0
    features: enterpriseFeatures
    perUser: false
    perActiveUser: false
    hidden: true
    purchaseOrder: true
  110:
    shortName: 'businessClass3x3Monthly'
    name: "Business Class"
    interval: 'monthly'
    price: 12.50
    features: businessClassFeatures_v3x3
    perUser: true
    perActiveUser: false
    yearlyEquivalent: 111
  111:
    shortName: 'businessClass3x3Yearly'
    name: "Business Class"
    interval: 'yearly'
    price: 119.99
    features: businessClassFeatures_v3x3
    perUser: true
    perActiveUser: false
  112:
    shortName: 'businessClass3x3PO'
    name: "Business Class v3.3 PO"
    interval: 'yearly'
    price: 0
    features: businessClassFeatures_v3x3
    perUser: false
    perActiveUser: false
    hidden: true
    purchaseOrder: true

opts =
  globalFeatures: ['logo']

  currentProducts:
    monthly: 'businessClass3x3Monthly'
    yearly: 'businessClass3x3Yearly'
  extras:
    BC1Products: [35, 36, 39, 40]
    currentPriceObjectForModel: (org) ->
      monthlyProduct = 'businessClass3x3Monthly'
      yearlyProduct = 'businessClass3x3Yearly'
      monthly:
        productNumber: @getProductNumber(monthlyProduct)
        price: @getPrice(monthlyProduct)
        totalPrice: org.totalPerUserPrice(monthlyProduct)
        monthlyPrice: @getPrice(monthlyProduct)
        totalMonthlyPrice: org.totalPerUserPrice(monthlyProduct)
      yearly:
        productNumber: @getProductNumber(yearlyProduct)
        price: @getPrice(yearlyProduct)
        totalPrice: org.totalPerUserPrice(yearlyProduct)
        monthlyPrice: @getPrice(yearlyProduct) / 12
        totalMonthlyPrice: org.totalPerUserPrice(yearlyProduct) / 12
        savePercent: @getYearlyDiscountPercent(yearlyProduct, monthlyProduct)
      billingStrategy: org.getBillingStrategy(yearlyProduct)

module.exports = new FeatureSet(products, opts)
